<script>

  import apiService from 'src/services/ApiService';
  import util from './SgsUtils';
  import moduleUtils from 'src/app/module/ModuleUtils';

  export default {
    props: [
      "attr", "value", "rules", "label",
      "showHint", "hintValue", "placeholder", "instance",
      "formIdentifier", "attrOriginal", "moduleType",
      "disableField"
    ],
    data(){
      return {
        localValue: '',
        localObject: {}
      }
    },
    watch: {
      value(val) {
        if (val) {
          this.getValue()
        } else {
          this.clearField();
        }
      },
      "localValue": function(val) {
        if (this.attr.eventOnChange) {
          this.$emit('callBusinessRule', this.attr.eventOnChange);
        }
      },
      "$i18n.locale": function() {
        this.getValue();
      }
    },
    methods: {
      openModal: function() {
        this.$eventBus.$emit(
          'auto-complete',
          {
            payload: {
              attr: this.attr,
              formIdentifier: this.formIdentifier,
              instance: this.instance
            },
            callback: this.selectRow
          }
        );
      },
      clearField: function () {
        this.updateFieldValue = '';
        this.localValue = '';
      },
      selectRow: function (row) {
        this.updateFieldValue = row[this.attr.columnValue];
        this.localValue = row[this.resolveColumnLabel()];
      },
      resolveColumnLabel: function() {
        let columnLabel = this.attr.columnLabel;

        if (this.$i18n.locale == 'es' && this.attr.columnLabelEs) {
          columnLabel = this.attr.columnLabelEs;
        } else if (this.$i18n.locale == 'en' && this.attr.columnLabelEn) {
          columnLabel = this.attr.columnLabelEn;
        }

        return columnLabel;
      },
      getValue: function() {

        if (this.value != undefined && this.value != "") {

          // TODO MOVER PARA UM UTILS, ESTA SENDO UTILIZADO NO SGS-RENDER-INPUT-DATA E INPUT-DATA-SHOW-OR-LIST
          let formIdentifier = Object.assign({}, this.formIdentifier, {formId: this.attr.formId});
          let parentFormId = this.formIdentifier.formId;

          moduleUtils.resolveModuleDescription(formIdentifier).then(response => {

            this.url = moduleUtils.resolveFormUri(formIdentifier) + "/autocompleteLoad";

          }).then(() => {

            let data = {}
            data._ = {}
            data._.parentFormId = parentFormId;
            data._.parentFormFieldId = this.attr.id;
            data._.fieldName = this.attr.columnValue;
            data._.fieldId = this.attr.columnValueFieldId;
            data._.fieldValue = this.value;
            data._.formId = this.attr.formId;

            return apiService.post({
              uri: this.url,
              data: data,
              excludeApi: true
            }).then(response => {
              if(response !== undefined) {
                this.localObject = response.body.instance;
              }
            }).then(() => {
              if (this.localObject !== null) {
                this.localValue = this.localObject[this.resolveColumnLabel()];
              }
            });
          });

        }
      }
    },
    computed: {
      updateFieldValue: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          if (this.attr.type == 'composition') {
            this.$emit('input', parseInt(newValue));
          } else {
            this.$emit('input', newValue);
          }
        }
      }
    },
    mounted() {
      this.getValue();
    },
    created() {
      util.resolveRules(this.attr, this.rules);
    }
  }
</script>
<template>
  <div>
    <el-popover
      ref="popover"
      v-show="showHint"
      placement="top-start"
      width="200"
      trigger="hover"
      :content="hintValue">
    </el-popover>

    <el-form-item label="temp" :prop="attr.columnName">

      <span slot="label">
        {{label}} <i v-if="showHint && moduleType === 'form'" class="glyphicon glyphicon-question-sign" v-popover:popover />
      </span>

      <el-input :placeholder="placeholder"
                v-model="localValue"
                readonly="readonly"
                :disabled="disableField">
        <el-button
          slot="prepend"
          icon="search"
          @click="openModal()"
          :disabled="disableField">
        </el-button>
        <el-button
          slot="append"
          @click.prevent="clearField()"
          icon="delete"
          :disabled="disableField">
        </el-button>
      </el-input>

    </el-form-item>

  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderInputData.vue?648bdf04